import type { RouteObject } from "react-router-dom";
import PipelinesList from "@via/pages/pipelines/pipelines-list.tsx";
import ProcessCatalogPage from "@via/pages/pipelines/processes/process-catalog-page.tsx";
import { ROUTES } from "@via/utils/constants.tsx";

/**
 * The static `/pipelines/processes` route sits beside `/pipelines`. Kept in its
 * own module so a route test can build a router from the same objects without
 * importing the whole application. React Router ranks a static segment above
 * `/pipelines/:pipelineId`, so "processes" is never read as a pipeline id.
 */
export const pipelinesRoutes: RouteObject[] = [
  { path: ROUTES.PIPELINES, element: <PipelinesList /> },
  { path: ROUTES.PIPELINE_PROCESSES, element: <ProcessCatalogPage /> },
];
